module.exports = __webpack_public_path__ + "media/images/left_arrow-41dd56bb1257246727235d771eebe924.svg";